import type { ThemeClasses } from "../../../types/components";

// Grid/list view toggle — copiado de
// pages/facturacion/users/components/UserViewToggle.tsx, tipado contra el
// ThemeClasses compartido. Reutilizado por cada tabla de la mini-app
// Equipo.
interface TeamMembersViewToggleProps {
  themeClasses: ThemeClasses;
  selectedView: "grid" | "list";
  onViewChange: (view: "grid" | "list") => void;
}

export function TeamViewToggle({
  themeClasses,
  selectedView,
  onViewChange,
}: TeamMembersViewToggleProps) {
  return (
    <div className="flex justify-end">
      <div
        className={`flex ${themeClasses.cardBg} border ${themeClasses.cardBorder} rounded-lg p-1`}
      >
        <button
          aria-label="grid"
          className={`px-3 py-1 rounded-md transition-colors ${
            selectedView === "grid"
              ? "bg-primary-500 text-white"
              : `${themeClasses.buttonText} ${themeClasses.buttonHover}`
          }`}
          onClick={() => onViewChange("grid")}
        >
          <i className="ri-grid-fill"></i>
        </button>
        <button
          aria-label="list"
          className={`px-3 py-1 rounded-md transition-colors ${
            selectedView === "list"
              ? "bg-primary-500 text-white"
              : `${themeClasses.buttonText} ${themeClasses.buttonHover}`
          }`}
          onClick={() => onViewChange("list")}
        >
          <i className="ri-list-check"></i>
        </button>
      </div>
    </div>
  );
}
